<template>
	<div>
		<vs-prompt
			id="div-with-loading1"
			class="vs-con-loading__container1"
			accept-text="حفظ"
			cancel-text="الغاء"
			title="تسجيل طالب جديد"
			@cancel="close"
			@accept="accept"
			@close="close"
			:active.sync="promptStatusForm"
			:is-valid="validInput"
		>
			<div class="con-exemple-prompt">
				<span>ادخل معلومات المستخدم: </span>
				<vs-input
					placeholder="اسم المستخدم"
					vs-placeholder="اسم المستخدم"
					v-model="dataObject.username"
					class="mt-3 w-full"
				/>
				<vs-input
					placeholder="الاسم الأول"
					vs-placeholder="الاسم الأول"
					v-model="dataObject.first_name"
					class="mt-3 w-full"
					required
				/>
				<vs-input
					placeholder="الاسم الأخير"
					vs-placeholder="الاسم الأخير"
					v-model="dataObject.last_name"
					class="mt-3 w-full"
					aria-required=""
				/>
				<vs-input v-if="dataObject.id == -1"
					placeholder="كلمة السر"
					vs-placeholder="كلمة السر"
					v-model="dataObject.password"
					class="mt-3 w-full"
				/>
				<vs-input v-if="dataObject.id == -1"
					placeholder="تأكيد كلمة السر"
					vs-placeholder="تأكيد كلمة السر"
					v-model="dataObject.confirm_password"
					class="mt-3 w-full"
				/>
				<vs-input
					placeholder="البريد الالكتروني"
					vs-placeholder="البريد الالكتروني"
					v-model="dataObject.email"
					class="mt-3 w-full"
				/>
				<vs-alert :active="!validInput" color="danger" vs-icon="new_releases" class="mt-4" >
					الرجاء إدخال المعلومات المطلوبة
				</vs-alert>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: {
		promptStatus: {
			required: true,
			type: Boolean
		},
		oldDataObject: {
			required: true,
			type: Object
		}
	},
	data() {
		return {
			status: false,
			dataObject: {
				id: -1,
				username: '',
				first_name: '',
				last_name: '',
				password: '',
				confirm_password: '',
				email: null
			},
			promptStatusForm: false
		};
	},
	mounted() {
		this.dataObject = this.oldDataObject;
	},
	computed:{
		validInput(){
		return (this.dataObject.first_name.length > 0 &&
		 this.dataObject.last_name.length > 0 &&
		 this.dataObject.username.length > 0 ) && (
			 this.dataObject.id != -1 ? true: (
				 this.dataObject.password.length > 0 &&
		 this.dataObject.password === this.dataObject.confirm_password
			 )
		 );

		}
  	},
	methods: {
		accept() {
			if(this.dataObject.id == -1)
				this.store();
			else this.edit();
		},
		close() {
			this.promptStatusForm = false;
			this.$emit("close", false);
			this.dataObject.name = '';
		},
		store() {
			this.promptStatusForm = true;
			this.$vs.loading({
				container: "#div-with-loading1",
				scale: 0.6
			});

			axios
				.post("/auth/signup", this.dataObject)
				.then(response => {
					this.promptStatusForm = false;
					this.$vs.loading.close("#div-with-loading1 > .con-vs-loading");
					if (response.status === 200) {
						this.$emit('updateStatus' , {isNew : true , data : response.data.data});
						this.$vs.notify({
							title: "تم الإضافة بنجاح",
							text: "تم إضافة التسجيلة بنجاح",
							color: "success",
							position: "top-left"
						});
					} else {
						this.$vs.loading.close("#div-with-loading1 > .con-vs-loading");
						this.$vs.notify({
							title: "خطأ",
							text: response.data.message,
							color: "danger",
							position: "top-left"
						});
					}
				})
				.catch(err => {
					this.$vs.notify({
						title: "خطأ",
						text: err.response.data.message,
						color: "danger",
						position: "top-left"
					});
					this.$vs.loading.close("#div-with-loading1 > .con-vs-loading");
				});

		},
		edit(){
			this.promptStatusForm = true;
			this.$vs.loading({
				container: "#div-with-loading1",
				scale: 0.6
			});

			axios
				.put("/students/" + this.dataObject.id, this.dataObject)
				.then(response => {
					this.promptStatusForm = false;
					this.$vs.loading.close("#div-with-loading1 > .con-vs-loading");
					if (response.status === 200) {
						this.$emit('updateStatus' , {isNew : false , data : response.data.data});
						this.$vs.notify({
							title: "تم التعديل بنجاح",
							text: "تم تعديل التسجيلة بنجاح",
							color: "success",
							position: "top-left"
						});
						this.dataObject.name = '';
					} else {
						this.$vs.loading.close("#div-with-loading1 > .con-vs-loading");
						this.$vs.notify({
							title: "Error",
							text: response.data.message,
							color: "danger",
							position: "top-left"
						});
					}
				})
				.catch(err => {
					this.$vs.notify({
						title: "Error",
						text: err.response.data.message,
						color: "danger",
						position: "top-left"
					});
					this.$vs.loading.close("#div-with-loading1 > .con-vs-loading");
				});
		}
	},
	watch: {
		promptStatus: function () {
			this.dataObject = this.oldDataObject;
			this.promptStatusForm = this.promptStatus;
		},
		oldDataObject: function() {
			this.dataObject = this.oldDataObject;
		}
	}
};
</script>
